import { Injectable } from '@angular/core';
import type { DetachedRouteHandle } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RouteReuseStoreService {
  private readonly handles = new Map<string, DetachedRouteHandle>();

  has(key: string): boolean {
    return this.handles.has(key);
  }

  get(key: string): DetachedRouteHandle | null {
    return this.handles.get(key) ?? null;
  }

  set(key: string, handle: DetachedRouteHandle): void {
    this.handles.set(key, handle);
  }

  remove(key: string): void {
    this.handles.delete(key);
  }

  clearAll(): void {
    this.handles.clear();
  }
}
